import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";


export const Contattaci = () => {
  return (
    <div className="flex flex-col items-center w-full bg-gradient-to-b from-gray-50 to-white">
      <Navbar />

      <main className="w-full max-w-7xl px-3 sm:px-4 md:px-6 py-6 md:py-12">
        {/* Hero Section */}
        <div className="mb-8 md:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-3 sm:mb-4 text-gray-800 font-elegant">
            Contattaci
          </h1>
          <p className="text-sm sm:text-base md:text-lg text-center text-gray-600 font-elegant max-w-3xl mx-auto">
            Se hai bisogno di assistenza, il nostro team di esperti è a tua completa
            disposizione per qualsiasi domanda, consiglio di stile o idea regalo.
            Non esitare a contattarci, siamo qui per te!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
          {/* Contact Cards */}
          <div className="space-y-4 sm:space-y-6">
            {/* Phone Card */}
            <a
              href="tel:+39039388876"
              className="block bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-4 sm:p-6 border-2 border-transparent hover:border-green-800 focus:outline-none focus:ring-4 focus:ring-green-800 transform hover:-translate-y-1"
              aria-label="Chiama il numero +39 039 388876"
            >
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="bg-green-100 rounded-full p-3 sm:p-4">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-green-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div className="flex-1 text-left">
                  <p className="text-xs sm:text-sm text-gray-600 font-elegant">Telefono</p>
                  <p className="text-base sm:text-lg md:text-xl font-bold text-gray-800 font-elegant">+39 039 388876</p>
                </div>
              </div>
            </a>

            {/* Email Card */}
            <a
              href="mailto:orologi.strippoli@gmail.com"
              className="block bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-4 sm:p-6 border-2 border-transparent hover:border-green-800 focus:outline-none focus:ring-4 focus:ring-green-800 transform hover:-translate-y-1"
              aria-label="Invia email a orologi.strippoli@gmail.com"
            >
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="bg-green-100 rounded-full p-3 sm:p-4">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-green-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="flex-1 text-left">
                  <p className="text-xs sm:text-sm text-gray-600 font-elegant">Email</p>
                  <p className="text-sm sm:text-base md:text-lg font-bold text-gray-800 font-elegant break-all">orologi.strippoli@gmail.com</p>
                </div>
              </div>
            </a>

            {/* Address Card */}
            <div className="bg-white rounded-xl shadow-lg p-4 sm:p-6">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="bg-green-100 rounded-full p-3 sm:p-4 flex-shrink-0">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-green-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div className="flex-1 text-left">
                  <p className="text-xs sm:text-sm text-gray-600 font-elegant">Indirizzo</p>
                  <p className="text-sm sm:text-base md:text-lg font-bold text-gray-800 font-elegant">Via Lecco, 18</p>
                  <p className="text-sm sm:text-base text-gray-600 font-elegant">20900 Monza (MB)</p>
                </div>
              </div>
            </div>

            {/* Store Image */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src="../img/rectangle-16-1@2x.png"
                alt="Orologeria e gioielleria Strippoli - Vetrina"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Map Section */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <iframe
              title="Mappa Google - Orologeria Strippoli Via Lecco 18, Monza"
              src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d89350.26410966784!2d9.200855806441302!3d45.586609441393016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x4786b9976de504d5%3A0xf5f87dfdfa46896d!2sVia%20Lecco%2C%2018%2C%2020900%20Monza%20MB!3m2!1d45.586543899999995!2d9.2830476!5e0!3m2!1sit!2sit!4v1732875301504!5m2!1sit!2sit"
              className="w-full aspect-video sm:aspect-[4/3] lg:aspect-square"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              aria-label="Mappa interattiva della sede Orologeria Strippoli in Via Lecco 18, Monza"
            ></iframe>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
